import { render, staticRenderFns } from "./info.vue?vue&type=template&id=68e36db6&scoped=true&%3Ais=view&transition=fade&transition-mode=out-in&"
import script from "./info.vue?vue&type=script&lang=js&"
export * from "./info.vue?vue&type=script&lang=js&"
import style0 from "./info.vue?vue&type=style&index=0&id=68e36db6&lang=less&scoped=true&"
import style1 from "./info.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e36db6",
  null
  
)

export default component.exports